<div class="chatter">
  <div class="chatter__container">
    <div #scrollContainer class="chatter__content">
      <div class="chatter-message-container col-xs-12 col-sm-12 col-md-8 col-lg-8"
           *ngFor="let command of commandsToRender">

        <app-chatter-message
          [message]="command.message"
          [origin]="command.type"
          (messageRendered)="next()"
          [variables]="memory"
          [field]="command.field">
        </app-chatter-message>
      </div>
    </div>

    <div class="chatter__input-bar">
      <div class="chatter__input-container col-xs-12 col-sm-12 col-md-8 col-lg-8">

        <h3 class="chatter__input-bar-text" *ngIf="notFound && activeControls === 'MODAL'">
          {{currentCommand?.skipMessage}}
        </h3>

        <h3 class="chatter__input-bar-text" *ngIf="responseItem && activeControls === 'MODAL'">
          {{'chatter.selectedLabel' | content}} {{responseItem[currentCommand.responseLabel]}}
        </h3>

        <div class="chatter__flex-container">
          <app-chatter-freeform
            *ngIf="activeControls === 'FREEFORM'"
            (responseEntered)="responseItem = $event">
          </app-chatter-freeform>

          <div *ngIf="activeControls === 'MULTI_SELECT' || activeControls === 'FROM_PROVIDED_DATA'"
               class="chatter__interest-selector">
            <app-interest-selector
              [interests]="activeSet"
              (selectedInterests)="setResponseItemWithInterests($event)">
            </app-interest-selector>
            <p class="chatter__interest-selector-no-choice">
              <a (click)="processResponse(responseItem = null)">
                <span>
                  {{ 'chatter.geenVanAllen' | content }}
                </span>
              </a>
            </p>
          </div>

          <app-chatter-provided-set
            *ngIf="activeControls === 'PROVIDED_SET' && activeSet"
            (itemSelected)="responseItem = $event"
            [setToProvide]="activeSet">
          </app-chatter-provided-set>

          <div *ngIf="activeControls === 'ENTITY_SELECTOR' && currentCommand"
               class="chatter__entity-selector">
            <app-entity-selector [naam]="nameFromEntitySelector"
                                 [mode]="currentCommand?.entityType"
                                 [filters]="currentCommand?.entitySelectorFilters"
                                 (entitySelected)="responseItem = $event">
            </app-entity-selector>
            <div *ngIf="currentCommand?.modalBlueprint" class="entity-options">
              <app-chatter-modal displayMode="text"
                                 class="chatter__modal-button"
                                 [buttonLabel]="'chatter.extendedSearchLink' | content"
                                 [blueprint]="currentModalBlueprint"
                                 [entityFilters]="currentCommand?.entitySelectorFilters"
                                 (selected)="responseItem = $event; nameFromEntitySelector = $event?.naam ? $event.naam : currentCommand?.typeNotFoundMessage"
                                 (notFound)="notFound = $event">
              </app-chatter-modal>
            </div>
            <div *ngIf="!currentCommand?.modalBlueprint" class="entity-options">
              <a class="chatter-modal-text" data-cy="EntiteitNietGevondenKnop"
                 (click)="notFound = true; responseItem = null; nameFromEntitySelector = currentCommand?.typeNotFoundMessage">
                <p>
                  {{currentCommand.skipMessage}}
                </p>
              </a>
            </div>
          </div>

          <div class="chatter__buttons">
            <app-chatter-modal *ngIf="activeControls === 'MODAL'"
                               displayMode="button"
                               class="chatter__modal-button"
                               [buttonLabel]="extractButtonLabel()"
                               [blueprint]="currentModalBlueprint"
                               (selected)="responseItem = $event"
                               (notFound)="notFound = $event">
            </app-chatter-modal>

            <button class="chatter__finalize-button"
                    (click)="finalize()"
                    data-cy="OpenPersoonlijkAdviesKnop"
                    *ngIf="activeControls === 'FINALIZE_FLOW'">
              {{finalCommand.finalActionLabel}}
            </button>

            <button class="chatter__next-button"
                    [disabled]="responseItem === undefined"
                    *ngIf="activeControls !== 'FINALIZE_FLOW' && !isMobile"
                    data-cy="VolgendeKnop"
                    (click)="processResponse(responseItem)">
              {{'chatter.nextButton' | content}}
            </button>

            <div class="chatter__response-bar-mobile"
                 *ngIf="isMobile"
                 [ngClass]="{'chatter__response-bar-mobile--shadow': activeControls === 'MULTI_SELECT'}">

              <div class="chatter__scroll-buttons-mobile"
                   *ngIf="activeControls === 'MULTI_SELECT' || activeControls === 'FROM_PROVIDED_DATA'">
                <mat-icon>expand_less</mat-icon>
                <mat-icon>expand_more</mat-icon>
              </div>

              <button class="chatter__next-button-mobile"
                      [disabled]="responseItem === undefined"
                      *ngIf="activeControls !== 'FINALIZE_FLOW'"
                      (click)="processResponse(responseItem)">
                <mat-icon class="material-icons">
                  send
                </mat-icon>
              </button>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</div>
